import type { COUNTRY } from '@clara/locale'

export const API_URL = process.env.REACT_APP_API_URL as string
export const OPERATION_COUNTRY = (process.env.REACT_APP_OPERATION_COUNTRY ||
  'MX') as COUNTRY

export const ZENDESK_HOST = process.env.REACT_APP_ZENDESK_HOST as string
